import { render, staticRenderFns } from "./ReportHuaningOweFeeDetail.vue?vue&type=template&id=204383c8&scoped=true"
import script from "./ReportHuaningOweFeeDetail.vue?vue&type=script&lang=js"
export * from "./ReportHuaningOweFeeDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportHuaningOweFeeDetail.vue?vue&type=style&index=0&id=204383c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204383c8",
  null
  
)

export default component.exports